"use client";

import React, { useState } from "react";
import { Search, MapPin, Navigation2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const locations = [{
  id: "1",
  city: "Midland, TX",
  status: "Active",
  x: 42,
  y: 48
}, {
  id: "2",
  city: "Granbury, TX\xA0",
  status: "Active",
  x: 38,
  y: 52
}];
export default function ServiceMap() {
  const [searchQuery, setSearchQuery] = useState("");
  const filteredLocations = locations.filter(loc => loc.city.toLowerCase().includes(searchQuery.toLowerCase()));
  return <section data-section-id="224783" id="our-locations" className="w-full bg-background py-12 md:py-24 text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-2xl space-y-2">
            <h2 className="font-default text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl text-primary">
              Our Locations
            </h2>
            <p className="text-muted-foreground md:text-lg font-default">Experience the M / O Protocol standard of wellness across West Texas and DFW, with protocols and products now available nationwide. Visit our flagship centers in Midland and Granbury.</p>
          </div>
        </div>

        <div className="flex h-[600px] w-full flex-col overflow-hidden rounded-xl border border-border bg-card shadow-xl md:h-[700px] md:flex-row">
          
          <div className="flex w-full flex-col border-b bg-sidebar md:w-80 md:border-b-0 md:border-r border-sidebar-border">
            <div className="p-4 border-b border-sidebar-border">
              <div className="relative">
                <Search className="absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
                <Input type="search" placeholder="Search cities..." className="w-full bg-background pl-9 border-input font-default" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
              </div>
            </div>
            <ScrollArea className="flex-1">
              <div className="p-2">
                {filteredLocations.length > 0 ? <ul className="space-y-1">
                    {filteredLocations.map((loc, i) => <li key={loc.id} data-index={i}>
                        <Link to="#" className="flex items-center justify-between rounded-md px-3 py-2 text-sm transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground">
                          <span className="font-default font-medium text-sidebar-foreground">{loc.city}</span>
                          <span className={`text-[10px] uppercase tracking-widest font-semibold px-2 py-0.5 rounded-full ${loc.status === "Active" ? "bg-primary/10 text-primary" : "bg-muted text-muted-foreground"}`}>
                            {loc.status}
                          </span>
                        </Link>
                      </li>)}
                  </ul> : <div className="p-4 text-center text-sm text-muted-foreground font-default">
                    No locations found matching "{searchQuery}"
                  </div>}
              </div>
            </ScrollArea>
          </div>

          
          <div className="relative flex-1 bg-transparent overflow-hidden">
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/texas_map_luxury.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/texas_map_luxury.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1652321/img/texas_map_luxury.png-wvc-sizes" alt="Texas Service Area Map" className="absolute inset-0 w-full h-full object-cover" loading="lazy" decoding="async" />
            
            
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#00000005_1px,transparent_1px),linear-gradient(to_bottom,#00000005_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" />

            <div className="absolute top-6 left-1/2 -translate-x-1/2 z-10 whitespace-nowrap">
              <div className="bg-[#8FA88F] backdrop-blur-md border border-border px-4 py-1.5 md:px-6 md:py-2 rounded-lg shadow-sm">
                <p className="text-[10px] md:text-xs font-default font-bold uppercase tracking-[0.2em] text-white">
                  Protocols & Products Available Nationwide
                </p>
              </div>
            </div>

            
            {filteredLocations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute -translate-x-1/2 -translate-y-1/2 group cursor-pointer transition-all duration-300 hover:z-10" style={{
            left: `${loc.x}%`,
            top: `${loc.y}%`
          }}>
                {loc.status === "Active" ? <div className="relative flex items-center justify-center">
                    <span className="absolute inline-flex h-10 w-10 animate-ping rounded-lg bg-primary opacity-10"></span>
                    <div className="relative flex h-8 w-8 items-center justify-center rounded-lg bg-background/80 backdrop-blur-md border border-primary/20 shadow-md">
                      <MapPin className="h-4 w-4 text-primary" />
                    </div>
                  </div> : <div className="flex h-5 w-5 items-center justify-center rounded-lg bg-muted border border-border">
                    <div className="h-2 w-2 rounded-lg bg-muted-foreground/40" />
                  </div>}

                
                <div className="absolute bottom-full left-1/2 mb-3 -translate-x-1/2 opacity-0 transition-opacity group-hover:opacity-100 pointer-events-none w-max z-20">
                  <div className="bg-background border border-border text-foreground text-xs rounded-lg px-4 py-3 shadow-2xl flex flex-col items-center gap-1">
                    <span className="font-default font-semibold text-sm tracking-tight">{loc.city}</span>
                    <span className={`text-[10px] uppercase tracking-widest font-bold ${loc.status === "Active" ? "text-primary" : "text-muted-foreground"}`}>
                      {loc.status}
                    </span>
                    <div className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 border-[6px] border-transparent border-t-background" />
                  </div>
                </div>
              </div>)}

            
            <div className="absolute bottom-6 right-6 flex flex-col gap-2">
              <Button size="icon" variant="secondary" className="h-10 w-10 bg-background/90 text-primary hover:text-primary-foreground border-border hover:bg-primary backdrop-blur-md shadow-lg rounded-lg transition-all">
                <Navigation2 className="size-5" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}